/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreSearchResponse } from '../../models/store-search-response';

export interface SearchStores$Params {
  'Active-Tenant-Identifier': string;
  page?: number;

/**
 * Size of the results page.
 */
  size?: number;
  sortBy?: string;
  orderBy?: string;

/**
 * Query parameter for doing a text search. Search against store name, address, city, state fields.
 */
  query?: string;
  isOrderingEnabled?: boolean;
  isChildStore?: boolean;
  isStoreHoursSet?: boolean;
  isDefaultTaxRateSet?: boolean;
  isChannelSetup?: boolean;
  isPaymentConfigured?: boolean;
  isPosConfigured?: boolean;
  isPosOnlineAndReady?: boolean;
  hasParentHub?: boolean;
  storeStatus?: Array<'new' | 'lab' | 'active' | 'nonOrderingStore' | 'temporarilyClosed' | 'permanentlyClosed'>;
  posStatus?: Array<'online' | 'onlineAndReady' | 'offline'>;
  posSystem?: Array<string>;

/**
 * filter stores by storeGroupId
 */
  storeGroupId?: Array<string>;

/**
 * External Store ID for reference to external systems
 */
  externalStoreId?: Array<string>;

/**
 * query to filter on entity attributes with an RSQL like syntax.
 * Supported operator: Eequality comparison `==`, contains operator `=in=` and AND logic operator `;`.
 * Values must be encoded.
 * Examples: `filter=name=="Some Store Name";` encoded as: `filter=name%3D%3D%22Some%20Store%20Name%22`
 * `filter=storeStatus=in=(live, permanentlyClosed);` encoded as: `filter=storeStatus%3Din%3D(live%2C%20permanentlyClosed)`
 */
  filter?: string;

/**
 * query to allow the selection of response payload attributes, allowing whoever calls this endpoint to retrieve only the attributes they need in each context.
 * Examples: `field=name&field=storeNumber`
 */
  field?: Array<string>;
}

export function searchStores(http: HttpClient, rootUrl: string, params: SearchStores$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchStores.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('query', params.query, {});
    rb.query('isOrderingEnabled', params.isOrderingEnabled, {});
    rb.query('isChildStore', params.isChildStore, {});
    rb.query('isStoreHoursSet', params.isStoreHoursSet, {});
    rb.query('isDefaultTaxRateSet', params.isDefaultTaxRateSet, {});
    rb.query('isChannelSetup', params.isChannelSetup, {});
    rb.query('isPaymentConfigured', params.isPaymentConfigured, {});
    rb.query('isPosConfigured', params.isPosConfigured, {});
    rb.query('isPosOnlineAndReady', params.isPosOnlineAndReady, {});
    rb.query('hasParentHub', params.hasParentHub, {});
    rb.query('storeStatus', params.storeStatus, {"style":"form","explode":true});
    rb.query('posStatus', params.posStatus, {"style":"form","explode":true});
    rb.query('posSystem', params.posSystem, {"style":"form","explode":false});
    rb.query('storeGroupId', params.storeGroupId, {"style":"form","explode":true});
    rb.query('externalStoreId', params.externalStoreId, {"style":"form","explode":true});
    rb.query('filter', params.filter, {});
    rb.query('field', params.field, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreSearchResponse>;
    })
  );
}

searchStores.PATH = '/stores';
